var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarPlus = function SvgCalendarPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2.5a.833.833 0 0 1 1.667 0v.833h6.666V2.5A.833.833 0 1 1 15 2.5v.833h1.667c.92 0 1.666.747 1.666 1.667v11.667c0 .92-.746 1.666-1.666 1.666H3.333c-.92 0-1.666-.746-1.666-1.666V5c0-.92.746-1.667 1.666-1.667H5V2.5ZM3.333 16.667V5h13.334v11.667H3.333Zm6.667-10a.833.833 0 0 0-.833.833V10h-2.5a.833.833 0 0 0 0 1.667h2.5v2.5a.833.833 0 0 0 1.666 0v-2.5h2.5a.833.833 0 0 0 0-1.667h-2.5V7.5A.833.833 0 0 0 10 6.667Z",
    fill: "#0163FF"
  })));
};
export default SvgCalendarPlus;